export default {
  // ========== Page 403 - Access Denied ==========
  page403Title: 'Restricted access',
  page403Message: 'Sorry, you do not have permission to view this page.',
  returnHome: 'Return to Home',

  // ========== Page 404 - Not Found ==========
  page404Title: 'Page not found!',
  page404Message: 'Sorry, the page you are looking for does not exist.',

  // ========== Page 500 - Server Error ==========
  page500Title: 'Server error',
  page500Message: 'Sorry, a server error has occurred.',

  // ========== Maintenance Page (PageMaintenance) ==========
  pageMaintenanceTitle: 'Page Under Maintenance',
  pageMaintenanceMessage: 'We are working to improve your experience. This page will be available again shortly.',
  pageMaintenanceButton: 'Return to Home',

  // ========== Maintenance View (MaintenanceView) ==========
  maintenanceViewTitle: 'Hello! We are currently under maintenance!',
  maintenanceViewMessage: 'Sorry for the inconvenience, but we are performing maintenance on the website. We will be back shortly. If you need to reach us urgently,',
  maintenanceViewEmailLink: 'you can send us an email',
  maintenanceViewTeam: '— The KLearning team',
}
